module.exports = __webpack_public_path__ + "img/ee85a2f.svg";